<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addError, addLog } from "../stores/LoggerStore";
  import SettingsMgr, {
    officialThemes,
    saveSettings,
    settingDescription,
  } from "../stores/SettingsMgr";
  import { setStorage } from "../scripts/utils";
  import ProcMgr, { loadBread, resetSaved, saveBread } from "../stores/ProcMgr";
  import { get } from "svelte/store";
  import { FileMgr } from "../stores/FileMgr";

  export let winProps: WinProps;
  winProps.name = winProps.name || "Settings";

  const procmgr = ProcMgr.getInstance();
  const _settings = SettingsMgr.getInstance();
  const _theme = _settings.theme;
  let { settingsStore } = _settings;
  let viewId = 1;
  const buildView = (settings) => {
    console.log("Watch settings called");
    const retval = [];
    for (let key in settings) {
      retval.push({
        id: viewId++,
        key: key,
        value: settings[key],
      });
    }
    return [...retval];
  };
  $: settingView = buildView($settingsStore);

  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    console.log("Watcher called. color : ", c["1"]);
    contElem.style.setProperty("color", c["1"]);
    return c;
  };
  $: _colors = themeWatcher($_theme);
  let contElem: HTMLElement;
  onMount(() => {
    themeWatcher($_theme);
    console.log("ss : ", get(settingsStore));
  });
  const toggleBoolean = (key: string) => {
    const found = _settings.getValue(key);
    if (found === undefined || found === null) {
      addError("Settings key [" + key + "] is not found");
      return;
    }
    _settings.set(key, !found);
  };
  let resetted = false;
</script>

<Window {winProps}>
  <div class="container" bind:this={contElem}>
    <h1>Settings</h1>
    <div class="settings-container">
      <div class="buttons">
        <button
          class="btn save"
          on:click={() => {
            saveBread();
          }}>Save</button
        >
        <button
          class="btn load"
          on:click={() => {
            loadBread();
          }}>Load</button
        >
        <button
          class="btn reset"
          on:click={() => {
            resetSaved();
            resetted = true;
          }}>Reset</button
        >
      </div>

      <div class="item">
        <div class="l head">Name</div>
        <div class="r head">Value</div>
      </div>
      {#each settingView as setting (setting.id)}
        <div class="item">
          <div class="l">
            {settingDescription[setting.key]}
          </div>
          {#if typeof setting.value === "boolean"}
            <div class="r">
              <div
                class="toggler"
                on:click={() => {
                  toggleBoolean(setting.key);
                  saveSettings();
                }}
              >
                {#if setting.value}
                  <img
                    src="/imgs/circlecheck.svg"
                    alt={`${settingDescription[setting.key]} being ${
                      setting.value
                    }`}
                    class="toggle-icon green"
                  />
                {:else}
                  <img
                    src="/imgs/circlex.svg"
                    alt={`${settingDescription[setting.key]} not ${
                      setting.value
                    }`}
                    class="toggle-icon yellow"
                  />
                {/if}
              </div>
            </div>
          {/if}
          {#if typeof setting.value === "string"}
            <div class="r string-setting">{setting.value}</div>
          {/if}
          {#if typeof setting.value === "number"}
            <div class="r number-setting">{setting.value}</div>
          {/if}
        </div>
      {/each}
    </div>
  </div>
</Window>

<style>
  .buttons {
    width: 100%;
    display: flex;
    gap: 10%;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 30px;
  }
  .buttons .btn {
    flex: 1;
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .reset {
  }
  .settings-container {
    width: 90%;
    display: flex;
    flex-direction: column;
  }
  .item {
    position: relative;
    margin: 10px auto;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    position: relative;
  }
  .head {
    font-size: 1.3rem;
    font-weight: 500;
    text-decoration: underline;
  }
  .l,
  .r {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .toggler {
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    overflow: hidden;
  }
  .toggle-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center, center;
  }
  .green {
    background-color: #5d5;
  }
  .yellow {
    background-color: yellow;
  }
</style>
